import { createApp } from 'vue';
import App from './App.vue';
import './styles/design-tokens.css';
import router from '@/app/router';
import i18n from './i18n';
import axios from 'axios';
import { API_BASE_URL } from '@/config/api';
import { installPosthog } from '@/plugins/posthog';
import dialogPlugin from '@/shared/ui/dialogService';
import { installUiLocalization } from '@/i18n/uiLocalization';

/**
 * Global Axios Interceptor
 * Rewrites any hardcoded http://localhost:5000 URLs to use the configured API_BASE_URL.
 * This ensures all API calls work in both development and production without
 * modifying every single component file.
 */
axios.interceptors.request.use(config => {
  if (config.url && config.url.includes('http://localhost:5000')) {
    config.url = config.url.replace('http://localhost:5000', API_BASE_URL);
  }
  return config;
});

const app = createApp(App).use(router).use(i18n).use(dialogPlugin);

// PostHog analytics (no-op in dev when VUE_APP_POSTHOG_KEY is empty).
// Must be installed AFTER router so the plugin can hook router.afterEach
// for SPA $pageview tracking.
installPosthog(app, router);

app.mount('#app');
installUiLocalization();
